.bg
  background-image: linear-gradient(45deg, config('colors.pacific-dark'), config('colors.denim'))
  transform: skewY(-6deg)
  transform-origin: top left
  @apply absolute pin z-0 h-full w-full
